import { css } from '@emotion/react';
import {
  ButtonComponent, ButtonStyle,
} from '~/_shared/baseComponents/buttons';
import { darkTheme } from '~/_shared/themes/dark.theme';
import type { Theme } from '~/_shared/themes/theme.model';
import { isPaidLicense } from '~/_shared/types/client/license.helpers';
import { useBookDemo } from '~/_shared/utils/3rdPartyIntegrations/bookDemo/bookDemo.hooks';
import { makeColorDarker } from '~/_shared/utils/colors/colors.helpers';
import { useTranslation } from '~/_shared/utils/hooks';
import { useUserCurrentClientSelector } from '~/store/userData/userData.selectors';

const buttonStyle = (theme: Theme) => css({
  backgroundColor: theme.iconColors.warning,
  borderColor: theme.buttonColors.defaultBorder,
  color: '#665500',
  '&:hover': {
    backgroundColor: makeColorDarker(theme.iconColors.warning).hex,
  },
});

const containerStyle = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'row',
  gap: 16,
  height: 38,
  marginTop: 15,
});

const textStyle = (theme: Theme) => css({
  color: theme.name === darkTheme.name ? theme.iconColors.warning : '#A38800',
  fontSize: 16,
  fontWeight: 'bold',
  margin: 0,
});

export const BookDemoComponent = () => {
  const [t] = useTranslation();
  const currentClient = useUserCurrentClientSelector();
  const onBookDemoClick = useBookDemo();

  const isPaidLicence = !!currentClient && isPaidLicense(currentClient.license.type);

  if (isPaidLicence) {
    return null;
  }

  return (
    <div css={containerStyle}>
      <div>
        <ButtonComponent
          text={t('bookDemo.title')}
          onClick={onBookDemoClick}
          buttonStyle={ButtonStyle.Custom}
          css={buttonStyle}
        />
      </div>
      <p css={textStyle}>{t('bookDemo.explanation.short')}</p>
    </div>
  );
};
